const DiagonalStripeBackground = ({ style, children }) => {
  return (
    <div
      style={{
        background: `repeating-linear-gradient(
          -45deg,
          #e8e8e8,
          #e8e8e8 2px,
          #f5f5f5 2px,
          #f5f5f5 8px
        )`,
        flex: 1,
        borderRadius: 24,
        position: 'relative', // CRITICAL: Anchors the absolute fill bar
        overflow: 'hidden',   // CRITICAL: Clips the fill bar to the rounded corners
        display: 'flex',
        justifyContent: 'center',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
export default DiagonalStripeBackground;